import styled from 'vue3-styled-components';

export const OrderModifyDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    min-height: calc(85vh - 100px);
    overflow-y: auto;
`;

export const OrderUpClientArea = styled.div`
    flex: 0.5;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    margin: 10px;
    border-radius: 20px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
`;

// !품목 주문서 Area
export const OrderModifyProductArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
`;

export const OrderModifyCenterArea = styled.div`
    width: 2%;
`;

export const RentalFooterArea = styled.div`
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 90px;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
    margin-top: 15px;
    z-index: 15;
`;

export const OrderUpProductTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    margin-top: 10px;
    
    th, td {
        padding: 8px 8px;
        text-align: center;
        vertical-align: middle;
        font-size: 14px;
        border-bottom: 1px solid #fb8b24; // 각 셀에 하단 테두리 추가
        
        &:first-child {
            border-left: 1px solid #fb8b24; // 첫 번째 열에 좌측 테두리 추가
        }

        &:last-child {
            border-right: 1px solid #fb8b24; // 마지막 열에 우측 테두리 추가
        }
    }

    th {
        background: #fb8b24;
        border-top: 1px solid #fb8b24; // 헤더 상단 테두리

        &:first-child {
            border-top-left-radius: 8px; // 좌측 상단 모서리
        }
        
        &:last-child {
            border-top-right-radius: 8px; // 우측 상단 모서리
        }
    }

    // 컬럼 너비 조정
    th:nth-child(1) { width: 5%; }  // 선택
    th:nth-child(2) { width: 15%; }  // 바코드
    th:nth-child(3) { width: 15%; }  // 품목분류
    th:nth-child(4) { width: 20%; }  // 품목명
    th:nth-child(5) { width: 15%; }  // 대여가격
    th:nth-child(6) { width: 7%; }   // 연장
    th:nth-child(7) { width: 5%; }   // 복사

    td {
        padding: 5px;
        background: #fff;
        > div {
            width: 100%;
            padding: 4px;
            text-align: center; // div도 중앙 정렬 추가
            &:last-child {
                border-bottom: none;
            }
        }
    }

    // 입력 필드가 있는 셀의 패딩 조정
    td input {
        width: 90%;
        padding: 6px;
        box-sizing: border-box;
    }
`;

export const OrderUpProductTableTheadTr = styled.tr`
    background-color: #fb8b24;
    color: #000;
    font-size: 13px;
    height: 30px;

    th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 12px 8px;
    }
`;

// 테이블을 감싸는 컨테이너 추가
export const OrderUpProductTableContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    overflow: hidden;
    box-sizing: border-box;
`;

export const OrderUpProductTableInputTxt = styled.input`
    width: 90%;
    height: 30px;
    padding: 0 5px;
    font-size: 13px;
`;

// ! 주문합계 영역
export const TotalSummaryContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #ffc971;
    border-left: 1px solid #fb8b24;
    border-right: 1px solid #fb8b24;
    border-bottom: 1px solid #fb8b24;
    border-radius: 0 0 10px 10px;
    margin-top: -2px;
`;

export const TotalInfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    font-size: 14px;
    color: #0f4c5c;
`;

// 오른쪽 총계 정보 컨테이너
export const SummaryRightContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 20px;
    margin-left: auto;
`;

// ! 버튼 영역
export const RentalSubmitBtn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0f4c5c;
    color: #fff;
    width: 100%;
    height: 27px;
    margin: 5px;
    border-radius: 3px;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    padding: 15px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderModifyServiceBtn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    padding: 15px;
    border-radius: 5px;
    background: #fbffff;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    margin: 5px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const FooterButtonArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100%;
    margin-left: 230px;
`;

export const OrderModifyServiceBtnArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100%;
`;

// !댓글 영역
export const OrderModifyClientTableMemoSelect = styled.select`
    width: 100%;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
`;

export const CommentImageUploadArea = styled.div`
    button{
        display: flex;
        align-items: center;
        box-shadow: 0 8px 9px -4px rgba(175, 156, 156, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
        background: #fff;
        font-weight: bold;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px 20px;
        margin: 5px;
        &:hover{
            background: #f0f0f0;
        }
    }
`;

export const ImageModal = styled.div`
  position: fixed;
  margin-top: 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  img {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }
`;

export const OrderModifyClientTableTd = styled.td`
    text-align: center;
    width: 130px;
    font-size: 14px;
    background: #fb8b24;
    color: #000;
`;

export const RentalTitle = styled.h1`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background-color: #f8f1e9;
  color: #cc5803;
  border: 2px solid #cc5803;
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const OrderUpTitleArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const OrderUpClientTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}`;

export const OrderUpClientInputTxtW150 = styled.input`
    width: 150px;
    height: 30px;

    &[readonly] {
      background-color: #f8f9fa;
      cursor: not-allowed;
      color: #333;
  }
`;

export const orderUpClientAddressBtn = styled.button`
    background: #ffffff;
    height: 28px;
    margin: 5px;
    border: 1px solid #000000;
    border-radius: 3px;
    box-shadow: 1px 1px 1px 1px #000000;
    font-size: 15px;
    cursor: pointer;
    width:150px;
`;

export const OrderUpClientInputTxtW260 = styled.input`
    width: 282px;
    height: 30px;
    
    &[readonly] {
    background-color: #f8f9fa;
    cursor: not-allowed;
    color: #333;
  }
`;

export const OrderUpClientSelectW162 = styled.select`
    width: 162px;
    height: 40px;

    &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
    color: #333;
  }
`;

export const OrderUpClientTableTr = styled.tr`
    margin: 10px;
`;

export const OrderUpClientInputTxtW80per = styled.input`
  width: calc(100% - 100px);
  min-width: 00px;  // 최소 너비 설정
  height: 35px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 10px;
  margin: 5px 0;
`;

export const OrderModifyClientMemoBtn = styled.span`
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
    padding:10px 20px;
    font-weight: bold;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderModifyClientMemoArea = styled.td`
  min-width: 500px;  // 최소 너비 설정
`;

export const ProductLabel = styled.div`
  font-weight: bold;
  font-size: 21px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
  color: #cc5803;
`;

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const ButtonGroupLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonGroupCenter = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const CenterSide = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CenterContent = styled.div`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background-color: #f8f1e9;
  color: #cc5803;
  border: 2px solid #cc5803;
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const HeaderButton = styled.button`
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 8px;
    font-weight:bold;
    background: #0f4c5c;
    color: #fff;
    font-size: 15px;
    margin-right: 5px;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-2px);
    }
`;

// ! 메모 영역 스타일
export const MemoContainer = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #fb8b24;
  box-shadow: 0 2px 4px 4px rgba(0, 0, 0, 0.1);
`;

// 메모 섹션 (한 줄에 배치)
export const MemoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    overflow: hidden;
`;

export const MemoInputArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: #fff;
`;

export const MemoInput = styled.input`
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #dee2e6;
  border-radius: 8px;

  &:hover {
    border-color: #0f4c5c;
  }
  
  &:focus {
    outline: none;
    border-color:  #0f4c5c;
  }
`;

export const MemoButton = styled.button`
  padding: 12px 20px;
  background: #0f4c5c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

    &:hover {
        transform: translateY(-3px);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

export const MemoHistoryItem = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eee;
  background: #fff;
  margin-bottom: 10px;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const MemoHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  .manager {
    font-weight: bold;
    color: #0f4c5c;
    font-size: 16px;
  }

  .date {
    color: #666;
    font-size: 14px;
  }
`;

export const MemoHistoryContent = styled.div`
  width: 100%;
  padding: 8px 0;
  
  span {
    font-size: 15px;
    color: #333;
    line-height: 1.5;
    word-break: break-all;
  }
`;

export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    margin: 0 auto;

    &:hover {
        opacity: 1;
        color: #ef4444;
    }
`;

// 이미지가 있는 경우를 위한 별도의 스타일
export const MemoHistoryItemWithImage = styled(MemoHistoryItem)`
  flex-direction: column;
  align-items: flex-start;
  
  ${MemoHistoryContent} {
    margin-bottom: 10px;
  }
`;

export const MemoImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
`;

export const MemoImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
`;

export const MemoImageUploadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 15px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  cursor: pointer;
  margin: 15px;
  &:hover {
    background: #f8f9fa;
  }
`;

// 대여 연장 컨테이너
export const ExtendRentalContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: center;
`;

// 대여 연장 입력 필드
export const ExtendRentalInput = styled.input`
    width: 60px;
    padding: 4px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    text-align: center;
    transition: border-color 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
    }
    
    &::placeholder {
        color: #999;
        font-size: 11px;
    }
`;

// 대여 연장 아이콘 버튼
export const ExtendRentalIconButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    
    &:hover {
        transform: scale(1.1);
    }
    
    &:active {
        transform: scale(0.95);
    }
`;

export const OrderCopyBtn = styled.button`
  cursor: pointer;
  color: #0f4c5c;
  background: none;
  border: none;
  padding: 5px 10px;
  font-size: 16px;
  transition: color 0.3s;
  font-weight: bold;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// * 공단 청구 타입 설정
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  pointer-events: auto;
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  width: 500px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  animation: modalSlideUp 0.3s ease-out;

  @keyframes modalSlideUp {
    from {
      transform: translate(-50%, -45%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%);
      opacity: 1;
    }
  }
`;

export const ModalTitle = styled.h2`
  text-align: center;
  margin-bottom: 2.5rem;
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
`;

export const ClaimTypeButton = styled.button`
  position: relative;
  padding: 2rem 1.5rem;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    border-color: #4dabf7;
    box-shadow: 0 8px 20px rgba(77, 171, 247, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, #4dabf7, #228be6);
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
    border-radius: 14px;
  }

  &:hover::before {
    opacity: 0.05;
  }
`;

export const ButtonContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
`;

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;

  ${ClaimTypeButton}:hover & {
    background: #e7f5ff;
  }

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
`;

export const ButtonText = styled.span`
  font-size: 17px;
  font-weight: 500;
  color: #495057;
  transition: color 0.3s ease;

  ${ClaimTypeButton}:hover & {
    color: #228be6;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
`;

export const CloseButton = styled.button`
  width: 30%;
  padding: 1rem;
  background: #0f4c5c;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto;
  display: block;

  &:hover {
    background: #1a6985;
    color: #fff;
  }
`;

// ! 문서 등록정보 영역
export const DocumentSection = styled.div`
    background: #f5f7fa;
    border-radius: 16px;
    border: 2px solid #0f4c5c;
    padding: 10px;
    padding-top: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-top: 20px;
    position: relative;
    overflow: hidden;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 6px;
    }
`;

export const DocumentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
`;

export const DocumentTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #0f4c5c;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 18px;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    background-color: #f5f7fa;
    color: #0f4c5c;
    border: 2px solid #0f4c5c;
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const FileUploadButton = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

export const FileDeleteButton = styled.button`
    padding: 6px;
    background: none;
    border: none;
    color: #ef4444;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.2s;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;

    &:hover {
        background: #fee2e2;
    }
`;

export const Table = styled.table`
    width: 100%;
    table-layout: fixed; /* 추가: 고정 레이아웃으로 정확한 정렬 */
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 10px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    overflow: hidden;
`;

export const TableHeader = styled.th`
    width: ${props => props.width || 'auto'};
    background: #0f4c5c;
    color: white;
    padding: 8px 12px;
    text-align: ${props => props.align || 'center'};
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.3px;
    border: none;
    vertical-align: middle; /* 추가: 수직 정렬 */
    
    &:first-child {
        border-top-left-radius: 10px;
    }
    
    &:last-child {
        border-top-right-radius: 10px;
    }
`;

export const TableCell = styled.td`
    width: ${props => props.width || 'auto'};
    padding: 8px 12px;
    text-align: ${props => props.align || 'center'};
    background: white;
    border-bottom: 1px solid #e5e9f0;
    vertical-align: middle;
    word-wrap: break-word;
    overflow: hidden;
    
    /* 삭제 버튼이 있는 셀의 경우 flex로 중앙 정렬 */
    &:has(${DeleteButton}) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    &:first-child {
        border-left: 1px solid #e5e9f0;
    }
    
    &:last-child {
        border-right: 1px solid #e5e9f0;
    }
    
    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        accent-color: #0f4c5c;
        cursor: pointer;
    }
`;

export const TableRow = styled.tr`
    transition: background-color 0.2s ease;
    
    &:hover td {
        background-color: #f8fafc;
    }
    
    &:last-child {
        td {
            border-bottom: 1px solid #e5e9f0;
            
            &:first-child {
                border-bottom-left-radius: 10px;
            }
            
            &:last-child {
                border-bottom-right-radius: 10px;
            }
        }
    }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
`;

export const Thumbnail = styled.img`
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    border: 2px solid #e5e9f0;
    
    &:hover {
        border-color: #0f4c5c;
    }
`;

export const EmptyMessage = styled.td`
    text-align: center;
    padding: 32px;
    color: #64748b;
    font-style: italic;
    background: #f8fafc !important;
    font-size: 15px;
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #0f4c5c;
    font-size: 16px;
    font-weight: 500;
    background: #f8fafc;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const PreviewModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.75);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const PreviewContent = styled.div`
    background: white;
    padding: 16px;
    border-radius: 12px;
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 6px;
`;

export const ClosePreviewButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: #000;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 25px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    z-index: 1001;
    padding-bottom: 4px;
`;

// * 서류 등록 디자인
export const RequiredDocsSection = styled.div`
  margin-top: 24px;
  margin-bottom: 32px;
  padding: 20px;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid #0f4c5c;
`;


export const RequiredDocsHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  
  & > svg {
    margin-right: 6px;
    color: #0f4c5c;
    font-size: 18px;
  }
`;

export const RequiredHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  background: linear-gradient(to right, rgba(15, 76, 92, 0.05), rgba(15, 76, 92, 0.02));
  border-left: 3px solid #0f4c5c;
  border-radius: 0 4px 4px 0;
  
  & > svg {
    margin-right: 8px;
    color: #0f4c5c;
    font-size: 18px;
    opacity: 0.8;
  }

  &:hover {
    background: linear-gradient(to right, rgba(15, 76, 92, 0.08), rgba(15, 76, 92, 0.04));
  }
`;

export const RequiredDocsList = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 10px;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const RequiredDocItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #e0e0e0;
  position: relative;
  transition: all 0.2s ease;
  font-size: 13px;
  
  &.doc-uploaded {
    border-color: #4CAF50;
    background-color: rgba(76, 175, 80, 0.05);
  }
  
  &:hover {
    border-color: #0f4c5c;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }
  
  & .doc-status {
    margin-right: 6px;
    font-size: 16px;
  }
  
  & span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const PasteFocusableSection = styled(DocumentSection)`
  &.paste-focus {
    outline-offset: -3px;
    background-color: rgba(76, 175, 80, 0.05);
    position: relative;
  }
  
  &.paste-focus::after {
    content: "파일 붙여넣기 가능 영역";
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #4CAF50;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    opacity: 0.9;
    animation: pulse 1.5s infinite;
  }
  
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const PasteHint = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  font-size: 13px;
  color: #fff;
  background-color: #4CAF50;
  padding: 5px 10px;
  border-radius: 4px;
  font-weight: bold;
  animation: fadeIn 0.5s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const PasteHintWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(5px); /* 아래로 자연스럽게 */
  }
`;

export const PasteHintHoverBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #fff;
  background-color: #4CAF50;
  padding: 5px 10px;
  border-radius: 6px;
  font-weight: 600;
  box-shadow: 0 3px 6px rgba(0,0,0,0.15);
  cursor: pointer;
  animation: fadeIn 0.4s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ClipboardIconWrapper = styled.span`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  animation: bounce 1.2s infinite;

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
  }
`;

export const PasteHintTooltip = styled.div`
  position: absolute;
  top: 100%;
  right: 1%;
  transform: translate(-50%, 5px);
  background-color: #fff;
  color: #333;
  padding: 14px 20px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #eaeaea;
`;

export const RequiredDocsButton = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 5px;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

export const ClaimServiceBtn = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 5px;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

// 청구 프로세스 컨테이너 - 컴팩트한 정부 스타일
export const ClaimProcessContainer = styled.div`
  margin: 20px 0;
  padding: 24px 24px 0 24px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #16a34a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 12px;
  }
`;

// 프로세스 단계들 컨테이너 - 가로 배치
export const ProcessStepsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 24px;
    left: 60px;
    right: 60px;
    height: 2px;
    background: #e2e8f0;
    z-index: 1;
  }
`;

// 개별 프로세스 단계 - 컴팩트한 카드 스타일
export const ProcessStep = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 2;
  min-height: 120px;
`;

// 단계 아이콘 컨테이너
export const StepIconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  border: 3px solid ${props => {
    if (props.active) return '#16a34a';
    if (props.inProgress) return '#eab308';
    return '#e2e8f0';
  }};
  background: ${props => {
    if (props.active) return '#f0fdf4';
    if (props.inProgress) return '#fefce8';
    return '#f8fafc';
  }};
  color: ${props => {
    if (props.active) return '#16a34a';
    if (props.inProgress) return '#eab308';
    return '#e2e8f0';
  }};
  
  ${props => props.active && `
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
    transform: scale(1.05);
  `}
  
  ${props => props.inProgress && `
    box-shadow: 0 4px 12px rgba(234, 179, 8, 0.3);
    transform: scale(1.05);
  `}
`;

// 단계 제목
export const StepTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// 단계 버튼 - 정부 스타일
export const StepButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 10px;
  min-width: 120px;
  justify-content: center;
  
  background: #16a34a;
  color: white;
  box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
  
  &:hover {
    background: #15803d;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(22, 163, 74, 0.4);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
  }
`;

// 단계 상태 - 컴팩트한 배지
export const StepStatus = styled.div`
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  
  &.completed {
    background: #dcfce7;
    color: #166534;
  }
  
  &.in-progress {
    background: #fef3c7;
    color: #92400e;
  }
  
  &.pending {
    background: #f1f5f9;
    color: #64748b;
  }
`;

// PDF 미리보기 컨테이너 - 더 큰 크기로 설정
export const PdfPreviewContainer = styled.div`
  width: 100%;
  min-width: 900px;  // 최소 너비 설정
  height: 85vh;      // 높이도 약간 증가
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

// PDF 미리보기 헤더
export const PdfPreviewHeader = styled.div`
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h3 {
    margin: 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }
`;

// PDF iframe - 더 큰 크기로 설정
export const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  min-width: 900px;  // 최소 너비 설정
  border: none;
  flex: 1;
  background: white;
`;

// PreviewContent 수정 - PDF 미리보기를 위한 더 큰 크기
export const PreviewContentPdf = styled.div`
  background: white;
  padding: 0;  // PDF 미리보기에서는 패딩 제거
  border-radius: 12px;
  position: relative;
  max-width: 85vw;    // 화면 너비의 95% 사용
  max-height: 85vh;   // 화면 높이의 95% 사용
  min-width: 900px;   // 최소 너비 설정
  width: 80vw;        // 기본 너비를 화면의 90%로 설정
  height: 80vh;       // 기본 높이를 화면의 90%로 설정
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ClaimLoadingMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 60px 40px;
    color: #1e293b;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    box-shadow: 
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    position: relative;
    overflow: hidden;
    margin: 20px 0;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(59, 130, 246, 0.1),
            transparent
        );
        animation: shimmer 2s infinite;
    }
    
    @keyframes shimmer {
        0% {
            left: -100%;
        }
        100% {
            left: 100%;
        }
    }
`;

export const ClaimLoadingSpinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #0f4c5c;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 24px;
    position: relative;
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const ClaimLoadingText = styled.p`
    margin: 0;
    font-size: 18px;
    color: #374151;
    font-weight: 600;
    letter-spacing: -0.025em;
    position: relative;
    z-index: 1;
    
    @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
    }
`;

// 유효기간 컨테이너
export const ValidityPeriodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

// 유효기간 입력 그룹
export const ValidityInputGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

// 유효기간 라벨
export const ValidityLabel = styled.label`
  font-size: 12px;
  color: #666;
  min-width: 40px;
  font-weight: 500;
`;

// 유효기간 날짜 입력 필드
export const ValidityDateInput = styled.input`
  width: 120px;
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #fb8b24;
    box-shadow: 0 0 0 2px rgba(251, 139, 36, 0.2);
  }
  
  &:hover {
    border-color: #fb8b24;
  }
`;

// 대여 이력 섹션 스타일 - 토스 스타일 (최적화)
export const RentalHistoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 20px;
`;

// 대여 이력 리스트 컨테이너
export const RentalHistoryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

// 대여 이력 카드
export const RentalHistoryItem = styled.div`
    margin-bottom: 0;
`;

export const RentalHistoryCard = styled.div`
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
`;

// 카드 헤더 - 한 줄 배치 최적화 (메모 포함)
export const RentalCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    gap: 12px;
    flex-wrap: wrap;
`;

export const RentalCardContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    flex-wrap: wrap;
    min-width: 0;
    overflow: hidden;
`;

export const RentalCardRight = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

// 회차 뱃지
export const PeriodBadge = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: #ffffff;
    font-size: 14px;
    border-radius: 6px;
    min-width: 50px;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(49, 130, 246, 0.2);
`;

// 구분선
export const InfoDivider = styled.div`
    width: 2px;
    height: 30px;
    background: #e5e8eb;
    flex-shrink: 0;
`;

// 기간 정보
export const PeriodInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    flex-shrink: 0;
`;

export const PeriodLabel = styled.span`
    font-size: 13px;
    color: #8b95a1;
    font-weight: 500;
    line-height: 1;
`;

export const PeriodValue = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
`;

// 결제 정보 아이템 (한 줄에 배치, 중앙 정렬)
export const PaymentInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    flex-shrink: 0;
    align-items: center;
    text-align: center;
`;

export const PaymentLabel = styled.span`
    font-size: 13px;
    color: #8b95a1;
    font-weight: 500;
    line-height: 1;
    text-align: center;
`;

export const PaymentValue = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
    text-align: center;
`;

export const PaymentAmount = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 700;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
    text-align: center;
`;

// 삭제 버튼
export const DeleteButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    color: #8b95a1;
    transition: all 0.2s ease;
    padding: 0;
    flex-shrink: 0;
    
    &:hover {
        background: #f2f4f6;
        color: #ef4444;
    }
    
    &:active {
        transform: scale(0.95);
    }
`;

// 카드 바디 (메모만)
export const RentalCardBody = styled.div`
    padding: 12px 18px 14px 18px;
    border-top: 1px solid #f2f4f6;
`;

export const MemoList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const MemoItem = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const MemoText = styled.div`
    font-size: 13px;
    color: #4e5968;
    line-height: 1.5;
    padding: 6px 10px;
    background: #f9fafb;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex: 1;
    word-break: break-word;
    
    &:hover {
        background: #f2f4f6;
    }
`;

// 통계 섹션
export const RentalHistoryStats = styled.div`
    margin-top: 20px;
`;

export const StatsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const StatsCardItem = styled.div`
    margin-bottom: 0;
`;

export const StatsCard = styled.div`
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.2s ease;
    
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }
`;

export const StatsCardHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 10px;
    gap: 24px;
    flex-wrap: wrap;
`;

export const StatsInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
`;

export const StatsDivider = styled.div`
    width: 1px;
    height: 40px;
    background: #e5e8eb;
    flex-shrink: 0;
`;

export const StatsTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #191f28;
    letter-spacing: -0.5px;
    line-height: 1.4;
    margin-left: 50px;
    margin-right: 50px;
`;

export const StatsLabel = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #8b95a1;
    letter-spacing: 0.3px;
`;

export const StatsValue = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #191f28;
    letter-spacing: -0.5px;
    line-height: 1.4;
`;

export const StatsMethodItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    
    &:last-child {
        border-bottom: none;
    }
`;

export const StatsMethodName = styled.span`
    font-size: 13px;
    color: #4e5968;
    font-weight: 500;
`;

export const StatsMethodAmount = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 700;
`;

export const StatsUnpaidAmount = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #ef4444;
    letter-spacing: -0.5px;
`;

export const RentalMemoItem = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const RentalMemoText = styled.div`
    font-size: 13px;
    color: #4e5968;
    line-height: 1.4;
    padding: 8px 10px;
    background: #f9fafb;
    border-radius: 6px;
    cursor: pointer;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
    
    &:hover {
        background: #f2f4f6;
    }
`;

// 메모 입력 필드 (한 줄에 배치)
export const HistoryMemoInput = styled.input`
    padding: 8px 10px;
    border: 2px solid #0f4c5c;
    border-radius: 6px;
    font-size: 13px;
    color: #191f28;
    background: #ffffff;
    font-family: inherit;
    flex: 1;
    min-width: 0;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 4px rgba(49, 130, 246, 0.1);
    }
    
    &::placeholder {
        color: #cbd5e0;
    }
`;

// 대여 이력 토글 버튼
export const ToggleHistoryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px;
    margin-top: 12px;
    background: #ffffff;
    border: 1px solid #e5e8eb;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #0f4c5c;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f8f9fa;
        border-color: #0f4c5c;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(49, 130, 246, 0.1);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

// 결제 상태 아이템 (중앙 정렬)
export const PaymentStatusItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex-shrink: 0;
    align-items: center;
    text-align: center;
`;

// 결제 상태 배지
export const PaymentStatusBadge = styled.span`
    font-size: 13px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    white-space: nowrap;
    text-align: center;
    
    ${props => {
    switch (props.status) {
      case 'paid': // 납부/완료
        return `
                    color: #16a34a;
                `;
      case 'unpaid': // 미납/미완료
        return `
                    color: #dc2626;
                `;
      case 'pending': // 대기
        return `
                    color: #6b7280;
                `;
      default:
        return `
                    color: #6b7280;
                `;
    }
  }}
`;

// 입금 처리 선택기 컨테이너
export const PaymentStatusSelector = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
`;

// 입금 처리 상태 선택 버튼
export const PaymentStatusButton = styled.button`
    padding: 4px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background-color: ${props => props.active ? '#2563eb' : '#ffffff'};
    color: ${props => props.active ? '#ffffff' : '#333333'};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background-color: ${props => props.active ? '#1d4ed8' : '#f5f5f5'};
        border-color: ${props => props.active ? '#1d4ed8' : '#d0d0d0'};
    }
    
    &:active {
        transform: scale(0.98);
    }
`;